import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import FixedNav from "@/components/FixedNav";
import HeroSection from "@/components/HeroSection";
import StatsSection from "@/components/StatsSection";
import ExperienceSection from "@/components/ExperienceSection";
import VideoSection from "@/components/VideoSection";
import HowItWorks from "@/components/HowItWorks";
import EventsSection from "@/components/EventsSection";
import RecentEvents from "@/components/RecentEvents";
import RentalSelector from "@/components/RentalSelector";
import FAQSection from "@/components/FAQSection";
import ReviewsSection from "@/components/ReviewsSection";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import CallButton from "@/components/CallButton";

const Index = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.slice(1);
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  }, [location]);
  return (
    <div className="min-h-screen bg-background">
      <FixedNav />
      <HeroSection />
      <StatsSection />
      <ExperienceSection />
      <VideoSection />
      <HowItWorks />
      <RentalSelector />
      <EventsSection />
      <RecentEvents />
      <ReviewsSection />
      <FAQSection />
      <Footer />
      <WhatsAppButton />
      <CallButton/>
    </div>
  );
};

export default Index;
